import { useRef } from 'react';

export const useToggleIndexes = (): {
  indexRefs: React.MutableRefObject<Array<Array<any | null>>>;
  toggleIndexes: (index: number) => void;
} => {
  const indexRefs = useRef<Array<Array<any | null>>>([]);

  const toggleIndexes = (index: number): void => {
    if (indexRefs.current && indexRefs.current[index]) {
      indexRefs.current[index].forEach(currentIndex => {
        if (currentIndex) {
          currentIndex.toggleIndex();
        }
      });
    }
  };

  return { indexRefs, toggleIndexes };
};
